export { default as TermsAndConditionsField } from './base';
export type { TermsAndConditionsFieldProps } from './index.types';
